<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>CHOISIR UN TYPE DE CONNEXION</h2>
          <ul>
            <li><a routerLink="/">Accueil</a></li>
            <li>Type de connexion</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="choose-login-area pt-100 pb-170">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="section-title text-center mb-5">
          <h2>Comment souhaitez-vous vous connecter ?</h2>
          <p class="text-muted">Choisissez le type de compte qui correspond à votre profil</p>
        </div>
      </div>
    </div>
    
    <div class="row g-4 justify-content-center">
      <!-- Comité d'Organisation Card -->
      <div class="col-lg-5 col-md-6">
        <div class="login-choice-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <i class="icofont-users-alt-4"></i>
            </div>
            <h3>Comité d'Organisation</h3>
          </div>
          <div class="card-body">
            <p>Accédez à l'interface de gestion et d'administration du système QUALIFPME</p>
            <ul class="features-list">
              <li><i class="icofont-check-circled"></i> Gestion des campagnes</li>
              <li><i class="icofont-check-circled"></i> Administration des utilisateurs</li>
              <li><i class="icofont-check-circled"></i> Suivi des évaluations</li>
              <li><i class="icofont-check-circled"></i> Rapports et statistiques</li>
            </ul>
          </div>
          <div class="card-footer">
            <a routerLink="/login" class="btn btn-primary w-100" role="button" tabindex="0">
              <i class="icofont-login"></i>
              Se connecter
            </a>
          </div>
        </div>
      </div>

      <!-- Entreprise Card -->
      <div class="col-lg-5 col-md-6">
        <div class="login-choice-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <i class="icofont-building"></i>
            </div>
            <h3>Entreprise</h3>
          </div>
          <div class="card-body">
            <p>Accédez à votre espace entreprise pour vous labelliser et gérer vos dossiers</p>
            <ul class="features-list">
              <li><i class="icofont-check-circled"></i> Demande de labellisation</li>
              <li><i class="icofont-check-circled"></i> Suivi de dossier</li>
              <li><i class="icofont-check-circled"></i> Gestion des documents</li>
              <li><i class="icofont-check-circled"></i> Consultation des résultats</li>
            </ul>
          </div>
          <div class="card-footer">
            <a routerLink="/login-as-company" class="btn btn-primary w-100" role="button" tabindex="0">
              <i class="icofont-login"></i>
              Se connecter
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>